import CommonComponents from '@/components/templates/common'
import PhoneIcon from '@/assets/templates/icons/phoneIcon'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './beauty-shop.views'

const BeautyShopHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage} afterBackgroundColor="#00000070" textColor="textSecondary">
        <Layout.Header backgroundColor="#ffffff" textColor="textPrimary">
          <CommonComponents.Wrapper>
            <Layout.Logo>
              {template.logo.src ? (
                <Layout.LogoImage src={template.logo.src} />
              ) : (
                <Layout.LogoText fontFamily={template.logo.fontFamily}>
                  {template.logo.text}
                </Layout.LogoText>
              )}
            </Layout.Logo>
            <Layout.Navigation textColor="primary" hasShoppingCart={template.sections.navigation.hasShoppingCart}>
              {/* Header Button - Primary text and outlined variant */}
              <Layout.Button 
                variant='outlined' 
                type='primary'         // Sets border and text color to primary
                textColor='textPrimary'    // Primary text color
              >
                <PhoneIcon />
                <span>{template.sections.navigation.ctaText}</span>
              </Layout.Button>
            </Layout.Navigation>
          </CommonComponents.Wrapper>
        </Layout.Header>

        <Layout.SubHeader>
          <Layout.SubHeaderTitle>{template.sections.header?.title}</Layout.SubHeaderTitle>
        </Layout.SubHeader>
      
        <Layout.HeroContainer>
          <Layout.TitleContainer>
            <Layout.Title>{template.sections.hero.title}</Layout.Title>
            <Layout.Subtitle>{template.sections.hero.subtitle}</Layout.Subtitle>
            
            {/* Hero CTA Button - Outlined variant with secondary text */}
            <Layout.CTA 
              variant="outlined" 
              type='secondary'        // Secondary border and text color
              textColor='textSecondary' 
            >
              {template.sections.hero.ctaText}
            </Layout.CTA>
          </Layout.TitleContainer>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default BeautyShopHero
